import React from 'react';
import styled from 'styled-components/macro';
import { useTranslation } from 'react-i18next';
import { FormControlLabel, Switch } from '@mui/material';
import { translations } from '../../../../locales/translations';
import { Dropdown } from '../../../components/Dropdown';
import { biStatus, biType } from '../../../../locales/types';

export function StatusFiltering(props) {
  const { allPending, setAllPending, setSelectedSection, setSelectedStatus, disabled } = props;
  const { t } = useTranslation();
  const biSections = ['', biType.ONEOFF, biType.RECURRING, biType.DEPOSIT, biType.CHANGEBILLDATE, biType.TERMINATION];
  const biStatuses = ['', biStatus.PENDING, biStatus.COMPLETE, biStatus.TBC, biStatus.NA];

  const handleAllPendingChange = event => {
    setAllPending(event.target.checked);
  };

  return (
    <Wrapper>
      {/*<div className="status-label">{t(translations.filterStatus)}:</div>*/}
      <FormControlLabel
        control={
          <Switch
            checked={allPending}
            onChange={handleAllPendingChange}
            className='switch'
            disabled={disabled}
          />
        }
        label={t(translations.pendingOnly)}
      />
      <Dropdown
        label={translations.biSection}
        valueList={biSections}
        defaultValue={''}
        readOnly={allPending || disabled}
        onSelectedValue={setSelectedSection}
      />
      <Dropdown
        label={translations.status}
        valueList={biStatuses}
        defaultValue={''}
        readOnly={allPending || disabled}
        onSelectedValue={setSelectedStatus}
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;

  .status-label {
    margin-right: 10px;
  }

  .MuiTypography-root {
    font-size: 14px;
  }
`;
